import React from "react";
import { connect } from "react-redux";
import { clearCart, removeItem, toggleCart } from "../../redux/cart/action";
import { serverResponse } from "../../util/fakeServer";
import ShareGroceryListBtn from "../share/ShareGroceryListBtn";
import { styles } from "./cart.styles";
import CartItem from "./CartItem";
import CompleteOrder from "./CompleteOrder";
import ExportWrapper from "./ExportWrapper";

const Cart = (props) => {
  const items = props.cartReducer.cart.map((item) => (
    <CartItem key={item.skul} item={item} />
  ));

  const totalCart = props.cartReducer.cart.reduce((s, a) => {
    // let totalItemPrice = a.currentPrice * a.quantity;

    return s + parseFloat(a.currentPrice);
  }, 0);

  return (
    <div className="globalCartContainer">
      <div className="wrapperContainer" style={styles.wrapperContainer}>
        <div style={styles.headerWrapper}>
          <h3 style={styles.title} className="text-center">
            Il tuo carrello
          </h3>

          <i
            onClick={() => props.toggleCart(props.cartReducer.isOpen)}
            className="fas fa-times text-white mr-3 fa-2x"
          ></i>
        </div>
        {/* <div className="disclaimer_prices">
        ATTENZIONE: è entrato in vigore il nuovo listino.
                <br />I prezzi aggiornati sono quelli riportati nel riepilogo
                dell'ordine prima della conferma
        </div> */}

        <div style={styles.wrapperItem}>{items}</div>

        <div>
          {props.cartReducer.cart.length > 0 && (
            <div className="d-flex" style={styles.buttonContainer}>
              {/* <ShareGroceryList /> */}
              {/* <Button
              variant="completeOrder p-2"
              className="d-flex align-items-center"
            >
              <FaStore className="me-2" />
              Completa ordine
            </Button> */}
              <ShareGroceryListBtn />
              {serverResponse.config.send_grocery_list_to_market && (
                <CompleteOrder />
              )}

              {serverResponse.config.export_list && <ExportWrapper />}
              {/* <button className="btn btn-success">convidivid ordine</button> */}
            </div>
          )}

          <div style={styles.totalCart}>
            <p style={styles.totalCartText}>totale: € {totalCart.toFixed(2)}</p>
            {props.cartReducer.cart.length > 0 && (
              <div
                onClick={() => {
                  props.clearCart();
                }}
              >
                <img
                  style={styles.clearCart}
                  className="img-fluid pointer"
                  src="https://view.interattivo.net/static/media/Cart_delete.3e6ffeed.svg"
                  alt="svuota carrello"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cartReducer: state.cartReducer
  };
};

export default connect(mapStateToProps, { clearCart, removeItem, toggleCart })(
  Cart
);
